import https from './httpStore'
import { Loading } from 'element-ui'
import { Message } from 'element-ui'
import qs from 'querystring'
const axios_1 = https.axios_1
const axios_2 = https.axios_2
const showImg = https.default_img_url
const imgUploadUrl = https.imgUploadUrl


let request = (url, data, func, method, noLoad = false, customBox = false) => {
  let loading;
  if (!noLoad) {
    loading = Loading.service({
      spinner: 'el-icon-loading',
      text: 'loading...'
    })
  }
  axios_1({
    method: method || 'post',
    url,
    params: method === 'get' ? data : null,
    data: method === 'get' ? null : data,
  }).then((res) => {
    if (!noLoad) {
      loading.close()
    }
    if (res.data.code != 200 && !customBox) {
      Message({ message: res.data.message, type: 'error' })
    }
    func(res)
  }).catch((res) => {
    if (!noLoad) {
      loading.close()
    }
    Message({ message: "request error " + res, type: 'error' })
    throw res
  })
}
let request2 = (url, data, func, method) => {
  axios_2({
    method: method || 'post',
    url,
    params: method === 'get' ? data : null,
    data: method === 'get' ? null : data,
  }).then((data) => {
    func(data)
  }).catch((data) => {
    Message({ message: "服务器错误" + data, type: 'error' })
    func(data, 'error')
    throw data
  })
}
let clearCache = (data, func) => {
  https.clearCache({
    method: 'post',
    data
  }).then(data => func(data)).catch(() => Message({ message: "缓存清除失败", type: 'error' }))
}
https.clearCache.interceptors.request.use(config => {
  config.headers['X-Auth-Key'] = 'a3e6b6bd8543b44c039c994a94ed308e48ba1'
  config.headers['X-Auth-Email'] = 'service.cloudflare@smalltreemedia.com'
  config.headers['Content-Type'] = 'application/json'
  return config
})
axios_1.interceptors.request.use(config => {
  config.headers['token'] = localStorage.getItem('token')
  if (config.data && config.data.formData) {
    config.data.formData = ''
    config.data = qs.stringify(config.data)
  }
  return config
})
export default {
  request, showImg, imgUploadUrl, request2, clearCache
}